<template>
  <div>
    <component :is="dashboardComponent" />
    
    <!-- Snackbar para mensagem de acesso negado -->
    <v-snackbar
      v-model="accessDeniedSnackbar"
      color="error"
      :timeout="5000"
      top
    >
      {{ accessDeniedMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="accessDeniedSnackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import DashboardOwner from './DashboardOwner.vue'
import DashboardManager from './DashboardManager.vue'
import DashboardNew from './DashboardNew.vue'

export default {
  name: 'Dashboard',

  components: {
    DashboardOwner,
    DashboardManager,
    DashboardNew,
  },

  data: () => ({
    accessDeniedSnackbar: false,
    accessDeniedMessage: '',
  }),

  computed: {
    dashboardComponent() {
      const user = this.getCurrentUser()
      
      // Se for PLATFORM_OWNER, mostrar dashboard de administração
      if (user && user.role === 'PLATFORM_OWNER') {
        return 'DashboardOwner'
      }
      
      // Se for MANAGER, mostrar dashboard de gestor
      if (user && user.role === 'MANAGER') {
        return 'DashboardManager'
      }
      
      // Caso contrário, dashboard normal do tenant
      return 'DashboardNew'
    },
  },

  mounted() {
    // Verificar se há mensagem de acesso negado na query
    if (this.$route.query.denied === '1') {
      this.accessDeniedMessage = this.$route.query.message || 'Acesso negado'
      this.accessDeniedSnackbar = true
      
      // Limpar query params
      this.$router.replace({ query: {} })
    }
  },

  methods: {
    getCurrentUser() {
      try {
        const userStr = localStorage.getItem('user')
        return userStr ? JSON.parse(userStr) : null
      } catch (error) {
        console.error('Erro ao recuperar usuário:', error)
        return null
      }
    },
  },
}
</script>
